import { Component, Input } from '@angular/core';
import { MediaTextInfo } from './section-media-text.module';

@Component({
  selector: 'app-section-media-text',
  templateUrl: './section-media-text.component.html',
  styleUrls: ['./section-media-text.component.css']
})
export class SectionMediaTextComponent {

  @Input() MediaTextInfo: MediaTextInfo = {
    showMaskPC: false,
    imageSrc: '',
    title: '',
    description: '',
    showButton: false,
    buttonText: '',
    buttonLink: '',
    openInNewTab: false,
    showImageSecondary: false,
    showRevert: false,
  };

}
